import { usePageContext } from "../../../hooks/context";
import { usePackage } from "../../../hooks/package";
import { isCreditWorthy } from "../helpers";
import { useChoosePackage } from "../hooks";
import { useOnboardingPackagesMap } from "./useOnboardingPackagesMap";
import { usePromotedPackage } from "./usePromotedPackage";

const useOnboardingPackages = () => {
	const { availablePackages, creditScore } = usePageContext(useChoosePackage);
	const { selectedPackage } = usePackage();

	const isRejected = !creditScore?.assessment || !isCreditWorthy(creditScore.assessment);

	const promotedPackage = usePromotedPackage();
	const onboardingPackagesMap = useOnboardingPackagesMap();
	const isEhandelPackagePromoted = promotedPackage?.packageId === "E-HANDEL-BAS";
	const isEhandelPackageSelected = selectedPackage?.packageId === "E-HANDEL-BAS";
	const isEhandelPackageAvailable = isEhandelPackagePromoted || isEhandelPackageSelected;

	let onboardingPackages = Object.entries(onboardingPackagesMap).filter(
		([packageId]) =>
			packageId !== promotedPackage?.packageId &&
			availablePackages?.find((p) => p?.packageId === packageId),
	);

	if (!isEhandelPackageAvailable) {
		onboardingPackages = onboardingPackages.filter(([packageId]) => packageId !== "E-HANDEL-BAS");
	}

	if (isRejected) {
		onboardingPackages = onboardingPackages.filter(
			([packageId]) => packageId !== "BAAS-FÖRETAG-VÄXA" && packageId !== "OVERDRAFTPACKAGE",
		);
	}

	return onboardingPackages;
};

export default useOnboardingPackages;
